import React from 'react';
import { Col, Container, Row } from 'reactstrap';

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid>
          <Row>
            <Col xs={12} sm={6}>
              <div className="text-center text-sm-start">
                {new Date().getFullYear()} © POS2U.
              </div>
            </Col>
            <Col xs={0} sm={6}>
              <div className="text-sm-end d-none d-sm-block">
                {/* <div className="text-sm-end d-none d-sm-block"> */}
                All rights reserved.
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
